import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add'
import Edit from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Access from '../../Utils/authorize';
import Axios from '../../REST/base';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';

function Workorder() {
    const navigate = useNavigate()

    const columns = [
        { field: 'name', headerName: 'Form Name', flex: 0.3, minVisible: 'xs' },
        { 
            field: 'adhoc', 
            headerName: 'Is Adhoc ?', 
            flex: 0.15,
            minVisible: 'xs',
            valueGetter: (params) => params.row.adhoc ? "Yes" : "No"
        },
        { field: 'description', headerName: 'Description', flex: 0.2, minVisible: 'md' },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.1,
            minVisible: 'md',
            valueGetter: (params) => params.row.status ? 'Enabled' : 'Disabled'
        },
        {
            headerName: 'Actions',
            flex: 0.15,
            field: '_id',
            minVisible: 'xs',
            renderCell: (params) => (
                <>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`createWorkorder/${params?.id}`);
                        }}
                        title="Edit"
                    >
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            // Toggle status here if needed
                        }}
                        title={params.row.status ? 'Disable' : 'Enable'}
                    >
                        {!params.row.status && <VisibilityIcon />}
                        {params.row.status && <VisibilityOffIcon />}
                    </IconButton>
                </>
            ),
        },
    ];

    const fetchWorkorders = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await Axios().get('Workorder/GetWorkorders', { params })

        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            return {
                data: result.data,
                pagination: { total: result.data.length, page: 1, totalPages: 1 }
            };
        }

        return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
    }, []);

    const handleRowClick = (row) => {
        navigate(`createWorkorder/${row._id}`);
    }

    return (
        <PageShell>
            <PageHeader
                title="Workorder"
                back
                onBack={() => navigate(-1)}
                actions={
                    Access.isInternal() ? (
                        <Action
                            primary
                            icon={<AddIcon />}
                            label="Create New Master Workorder"
                            onClick={() => navigate('createWorkorder')}
                        />
                    ) : null
                }
            />

            <PageContent fill>
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchWorkorders}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    getRowId={(i) => i?._id}
                    onRowClick={handleRowClick}
                />
            </PageContent>
        </PageShell>
    )
}

export default Workorder;
